<nav class="emphasized tab-group">
  @let mode = orientation();
  @if (selectedListItem()) {
    <div
      class="selected-highlight border-radius-100"
      [style.left.px]="mode === 'horizontal' ? offsetLeft() : undefined"
      [style.top.px]="mode === 'vertical' ? offsetTop() : undefined"
      [style.width.px]="clientWidth()"
      [style.height.px]="clientHeight()"
    ></div>
  }
  <ul [class.vertical]="mode === 'vertical'">
    @for (tab of tabs(); track tab.alias) {
      <li
        [attr.id]="tab.alias"
        [attr.data-pw]="'go-to-' + tab.alias + '-page'"
        [class.selected]="selectedTab() === tab.alias"
        [icon]="tab.icon ?? ''"
        (click)="goTo.emit(tab.alias)"
      >
        <p class="dense tab-text">
          {{ tab.label }}
        </p>
      </li>
    }
  </ul>
</nav>
